import { render, staticRenderFns } from "./Setp.vue?vue&type=template&id=5cb4361a&scoped=true"
import script from "./Setp.vue?vue&type=script&lang=js"
export * from "./Setp.vue?vue&type=script&lang=js"
import style0 from "./Setp.vue?vue&type=style&index=0&id=5cb4361a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb4361a",
  null
  
)

export default component.exports